export default "__VITE_ASSET__BQaoXrl9__"